import React, { lazy } from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterWoningpresentatiePage() {
  return <ClusterPageTemplate clusterName="Woningpresentatie" sectorName="Makelaars & Vastgoed" sectorSlug="makelaars-vastgoed" heroTitle="Website laten maken voor woningpresentatie" heroDescription="Visueel verbluffende websites voor vastgoedfotografen, stylisten en inmeters. Wij bouwen portfolio's die jouw visuele werk perfect tot zijn recht laten komen." websiteOnderdelen={[{
    icon: 'CameraIcon',
    title: 'Portfolio',
    description: 'Een fullscreen, razendsnelle fotogalerij die jouw beste vastgoedfotografie en stylingprojecten toont.'
  }, {
    icon: 'BriefcaseIcon',
    title: 'Diensten & Pakketten',
    description: 'Heldere overzichten van je diensten: fotografie, video, 360-tours, inmeten (NEN2580) en styling.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Tarieven & Boeken',
    description: 'Transparante pakketprijzen en een module waarmee makelaars direct een shoot kunnen inplannen.'
  }, {
    icon: 'UsersIcon',
    title: 'Over de maker',
    description: 'Jouw visie op beeld en ruimte, en waarom makelaars jou hun vastgoedpresentatie moeten toevertrouwen.'
  }]} functionaliteiten={[{
    icon: 'CameraIcon',
    title: 'Beeldoptimalisatie',
    description: "Geavanceerde technieken zodat je website razendsnel laadt, ondanks de vele hoge resolutie foto's."
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Boekingssysteem',
    description: 'Een afspraakplanner speciaal ingericht voor makelaars om snel een moment te prikken.'
  }, {
    icon: 'FileTextIcon',
    title: 'Bestelformulier',
    description: 'Een formulier waar klanten direct de gewenste diensten (foto, video, plattegrond) kunnen aanvinken.'
  }]} siblingClusters={[{
    name: 'Makelaar',
    slug: 'makelaar'
  }, {
    name: 'Projectontwikkelaar',
    slug: 'projectontwikkelaar'
  }, {
    name: 'Vastgoedbeheer',
    slug: 'vastgoedbeheer'
  }]} faqs={[{
    q: "Wordt mijn website niet traag door alle grote foto's?",
    a: 'Nee, wij gebruiken moderne technieken zoals WebP-conversie, lazy loading en caching. Hierdoor laadt je portfolio razendsnel, wat cruciaal is voor SEO en gebruikservaring.'
  }, {
    q: 'Kunnen makelaars direct een shoot boeken via de site?',
    a: 'Ja, we kunnen een boekingsmodule of een uitgebreid bestelformulier integreren waarmee makelaars 24/7 opdrachten kunnen inschieten.'
  }, {
    q: 'Wat kost een website voor een vastgoedfotograaf?',
    a: "Een visueel sterke, snelle portfolio-website start vanaf €1.500. Dit is inclusief de inrichting van je galerijen en dienstenpagina's."
  }, {
    q: 'Kan ik zelf makkelijk nieuwe shoots toevoegen?',
    a: 'Absoluut. We richten het CMS zo in dat je met een paar klikken een nieuwe woning aan je portfolio kunt toevoegen.'
  }]} data-id="element-1095" />;
}